import { useState } from 'react';
import { supabase } from '@/lib/supabase';

export default function AdminPasswordReset() {
  const [email, setEmail] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState<{ type: 'success' | 'error'; text: string } | null>(
    null,
  );

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setMessage(null);

    if (!email.trim() || newPassword.length < 6) {
      setMessage({ type: 'error', text: '이메일과 6자 이상의 새 비밀번호를 입력해주세요.' });
      return;
    }

    setBusy(true);
    const { data, error } = await supabase.functions.invoke('admin-reset-password', {
      body: { email: email.trim(), newPassword },
    });
    setBusy(false);

    if (error) {
      setMessage({ type: 'error', text: '비밀번호 변경 중 오류가 발생했습니다.' });
      return;
    }
    if (!data?.success) {
      setMessage({ type: 'error', text: data?.message || '비밀번호 변경에 실패했습니다.' });
      return;
    }

    setMessage({ type: 'success', text: '비밀번호가 변경되었습니다.' });
    setEmail('');
    setNewPassword('');
  };

  return (
    <section>
      <h2 className="font-heading text-lg font-bold text-foreground-950 mb-1">비밀번호 초기화</h2>
      <p className="text-sm text-foreground-500 mb-3">
        특정 계정의 비밀번호를 직접 변경할 수 있어요 (운영자 전용)
      </p>

      <div className="bg-white rounded-xl border border-background-200 p-5">
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <label className="block">
              <span className="block text-sm font-medium text-foreground-700 mb-1.5">
                대상 이메일
              </span>
              <input
                type="email"
                name="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-3 py-2 text-sm rounded-md border border-background-300 bg-background-50 focus:outline-none focus:ring-2 focus:ring-primary-300"
                placeholder="name@example.com"
              />
            </label>
            <label className="block">
              <span className="block text-sm font-medium text-foreground-700 mb-1.5">
                새 비밀번호
              </span>
              <input
                type="text"
                name="new_password"
                required
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="w-full px-3 py-2 text-sm rounded-md border border-background-300 bg-background-50 focus:outline-none focus:ring-2 focus:ring-primary-300"
                placeholder="6자 이상"
              />
            </label>
          </div>

          {message && (
            <div
              className={`text-sm rounded-md px-3 py-2 ${
                message.type === 'success'
                  ? 'text-primary-700 bg-primary-50 border border-primary-200'
                  : 'text-red-600 bg-red-50 border border-red-200'
              }`}
            >
              {message.text}
            </div>
          )}

          <button
            type="submit"
            disabled={busy}
            className="whitespace-nowrap inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white text-sm font-semibold px-5 py-2 rounded-md transition-colors cursor-pointer disabled:opacity-60"
          >
            <i className="ri-key-2-line"></i>
            {busy ? '변경 중...' : '비밀번호 변경'}
          </button>
        </form>
      </div>
    </section>
  );
}